import * as Yup from 'yup';
import { PROJECT_TYPES } from '../../constants';

export const createProjectFormYupValidation = () => {
  return Yup.object().shape({
    projectName: Yup.string().required('required'),
    projectType: Yup.string().required('required'),
    resonanceTheme: Yup.string().when('projectType', ([projectType], schema) => {
      if (projectType === PROJECT_TYPES.RESONANCE) {
        return schema.required('required');
      }
    }),
    file: Yup.mixed().when('projectType', ([projectType], schema) => {
      if (projectType === PROJECT_TYPES.RESONANCE || projectType === PROJECT_TYPES.SONAR) {
        return schema.required('required');
      } else {
        return schema.nullable();
      }
    }),
  });
};

export const createSonarProjectYupValidation = () => {
  return Yup.object().shape({
    projectName: Yup.string().required('required'),
    startingFromMonth: Yup.string().required('required'),
    startingFromYear: Yup.string().required('required'),
    rangeType: Yup.string().required('required'),
  });
};

export const createResonanceProjectYupValidation = () => {
  return Yup.object().shape({
    projectName: Yup.string().required('required'),
    resonanceTheme: Yup.string().required('required'),
    dataStructure: Yup.string().required('required'),
    file: Yup.mixed().required('required'),
  });
};

export const createScoutProjectYupValidation = () => {
  return Yup.object().shape({
    projectName: Yup.string().required('required'),
    activeAllAssistants: Yup.array().required().min(1, 'pleaseChooseAtLeastOneAssistant'),
    activeSelectedAssistants: Yup.array().required().min(1, 'pleaseChooseAtLeastOneAssistant'),
    activeCompressAssistants: Yup.array().required().min(1, 'pleaseChooseAtLeastOneAssistant'),
  });
};

export const createGenieProjectYupValidation = () => {
  return Yup.object().shape({
    projectName: Yup.string().required('required'),
    brand: Yup.string().required('required'),
    activeAllAssistants: Yup.array().required().min(1, 'pleaseChooseAtLeastOneAssistant'),
  });
};

export const createGenieGoProjectYupValidation = () => {
  return Yup.object().shape({
    projectName: Yup.string().required('required'),
    brand: Yup.string().required('required'),
    activeAllAssistants: Yup.array().required().min(1, 'pleaseChooseAtLeastOneAssistant'),
    description: Yup.string().required('required'),
    referenceMessages: Yup.string().required('required'),
  });
};

export const createId8ProjectYupValidation = () => {
  return Yup.object().shape({
    projectName: Yup.string().required('required'),
    instructions: Yup.string().required('required'),
    agentId: Yup.string().required('required'),
  });
};

export const createActiv8ProjectYupValidation = () => {
  return Yup.object().shape({
    projectName: Yup.string().required('required'),
    activeUsers: Yup.array().required().min(1, 'pleaseChooseAtLeastOneUser'),
  });
};
